import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const AboutKyuOsWayfindingActivateProfileMenuWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const AboutKyuOsWayfindingActivateProfileMenuContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 156px);
  grid-column-gap: 8px;
  grid-row-gap: 16px;

  form {
    display: none;
  }

  ${BREAKPOINTS.tablet} {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const AboutKyuOsWayfindingActivateProfileMenuTitle = styled.h5`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.1em;
  text-transform: uppercase;

  color: var(--color-data-people-background);
`;

//CARD
export const AboutKyuOsWayfindingActivateProfileMenuCard = styled.div`
  width: 156px;
  height: 156px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;

  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 6px 24px 0px rgba(0, 0, 0, 0.1);

  cursor: pointer;
`;

export const AboutKyuOsWayfindingActivateProfileMenuCardTitle = styled.span`
  display: inline;

  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  text-align: center;

  & > svg {
    min-width: 24px;
    min-height: 24px;

    transform: translateY(6px) translateX(2px);
  }

  color: var(--color-text);
`;

export const AboutKyuOsWayfindingActivateProfileMenuCardIconsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const AboutKyuOsWayfindingActivateProfileMenuCardCTAIconContainer = styled.div`
  width: 24px;
  height: 24px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 8px;
  background-color: #f2f2f2;
`;
